import { Link, useLocation } from "react-router-dom";
import { BiLinkExternal } from "react-icons/bi";
import TranslatableText from "@components/translations/TranslatableText";
import { baseUrl } from "@app/apiSlice";
import { TranslationKey } from "@typedefs/modulesInterfaces";

export type HelpNavSection = "faqs" | "training" | "publications" | "release-notes";

type HelpNavCardProps = {
	section: HelpNavSection;
	translationKey: TranslationKey;
};

const releaseNotesUrl = `${baseUrl}blog/ui/`;

const HelpNavCard = ({ section, translationKey }: HelpNavCardProps) => {
	const { pathname } = useLocation();

	if (section === "release-notes") {
		return (
			<button
				type="button"
				className="help-center__nav-card help-center__nav-card--external br-8"
				onClick={() =>
					window.open(releaseNotesUrl, "_blank", "noopener,noreferrer")
				}
				aria-label="Release notes (opens in a new tab)"
			>
				<TranslatableText
					translationKey={translationKey}
					className="ff-medium-ext fs-14"
				/>
				<BiLinkExternal size={20} color="black" aria-hidden />
			</button>
		);
	}

	const to = `/help/${section}`;
	const isActive = pathname === to;

	return (
		<Link
			to={to}
			className={`help-center__nav-card br-8${isActive ? " help-center__nav-card--active" : ""}`}
		>
			<TranslatableText
				translationKey={translationKey}
				className="ff-medium-ext fs-14"
			/>
		</Link>
	);
};

export default HelpNavCard;
